import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { EventDetails } from 'src/Components/Calendars/EventDetails';
import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import useFetchExportedEvent from 'src/Hooks/Queries/useFetchExportedEvent';

type EventParams = {
  token: string;
  eventId: string;
};

const ViewExportedEventDrawer = () => {
  const { t } = useTranslation();
  const { eventId, token } = useParams<EventParams>();
  const [searchParams] = useSearchParams();
  const occurrenceStartTime = useMemo(() => {
    const startTime = searchParams.get('startTime');
    if (startTime) return dayjs(startTime);
  }, [searchParams]);

  const { data: event, isLoading } = useFetchExportedEvent({ token, eventId });

  if (!eventId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('eventDetailsDrawer.title', 'Événement')}>
      {() => (
        <EventDetails
          event={event}
          isLoading={isLoading}
          occurrenceStartTime={occurrenceStartTime}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default ViewExportedEventDrawer;
